import ScrTitle from './title/main';
import ScrStart from './start/main';
import ScrMovie from './movie/main';
import ScrApp from './app/main';
import UrlUtils from '../common/utils/url';


export default class Main{

    constructor(){
        this._init();
    }


    _init(){
        this.query = UrlUtils.getQuery();

        this.$attention = document.querySelector('.js-attention');

        this.title = new ScrTitle();
        this.start = new ScrStart();
        this.movie = new ScrMovie();
        this.app = new ScrApp();
        window.englishplus = this;

        document.querySelector('.js-confirm_close').addEventListener('click', ()=>{
            document.querySelector('.js-btn_return').classList.remove('-disable');

            // 開発用
            if(!parseInt(this.query.jump)){
                this.title.render(this._setBrightCove.bind(this));
                this.movie.init();
            }
            else{
                this._gameStart();
            }
        });
    }


    _setBrightCove(){
        this.movie.render(this._onStart.bind(this));
    }

    _onStart(){
        this.movie.dispose();
        this.start.render(this._gameStart.bind(this));
    }

    _gameStart(){
        this.app.render();
        document.querySelector('.js-scr-start').classList.remove('-active');
        document.querySelector('.js-scr-title').classList.add('-disable');
    }
}